import {connect} from "react-redux";
import CarServiceAccount from "./Save";
import {bindActionCreators} from "redux";
import {accountById} from "../../../../service/Valet/action";
import {locationPinCode, locationCity, locationZone, locationArea, stateAndRegion} from "../../../../service/locations/action";
import {saveAccount, sitePocTypes, oemManufactureName} from "../../../../service/CarService/action";

const mapStateToProps = (state) => ({
    saveDetails:state.CarService.saveDetails,
    pocTypes:state.CarService.pocTypes,
    eomName:state.CarService.eomName,
    pincodeData: state.locationReducer.pincodeData,
    cities: state.locationReducer.cities,
    zones: state.locationReducer.zones,
    areas: state.locationReducer.areas,
    accountDetailsByIdData:state.Valet.accountById,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            saveAccount,
            locationCity,
            locationPinCode,
            locationZone,
            locationArea,
            stateAndRegion,
            accountById,
            sitePocTypes,
            oemManufactureName
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(CarServiceAccount);
